<template>
    <transition name="HotspotEntrance">
        <router-link class="Hotspot" v-show="ready" :to="hotspot.route"
            :class="[getHotspotMutatorClasses, getHotspotContentClass, getHotspotTypeClass]" :style="[getPosition]"
            @click="hotspotPressed">

            <div class="Hotspot__button" :style="[getAlternateHotspotIcon, getContinuousHotspotAnimation]"></div>
            <span v-html="getHotspotTitle"></span>

        </router-link>
    </transition>
</template>

<script>

export default {
    props: ['hotspot'],
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.renderHotspotCascade();
    },
    methods: {
        renderHotspotCascade() {
            let delay = 0;
            delay = (this.hotspot.index * 200) + 400;

            setTimeout(() => {
                this.ready = true;
            }, delay);
        },
        hotspotPressed() {
            this.$emit('hotspotPressed', this.hotspot)
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for randomly timed animations
            return Math.random() * (max - min) + min;
        },
    },
    computed: {
        getPosition() {
            return {
                left: this.hotspot.data.positionData.xPosition + 'px',
                top: this.hotspot.data.positionData.yPosition + 'px'
            }
        },
        getHotspotTitle() {
            return this.hotspot.data.alternateTitle && this.hotspot.data.alternateTitle !== '' ? this.hotspot.data.alternateTitle : this.hotspot.data.title;
        },
        getHotspotTypeClass() {
            let hotspotPrefix = "Hotspot--"

            switch (this.hotspot.data.hotspotType) {
                case "No Label":
                    return `${hotspotPrefix}NoLabel`
                case "Production":
                    return `${hotspotPrefix}Production`
                case "Warehouse":
                    return `${hotspotPrefix}Warehouse`
                case "Milk Reception":
                    return `${hotspotPrefix}Milk`

                // more types can be added here through the backend hotspotType data value.

                default:
                    return
            }
        },
        getHotspotMutatorClasses() {
            return {
                'Hotspot--flipped': this.hotspot.data.flipped,
                'Hotspot--customicon': this.hotspot.data.alternateHotspotIcon !== null
            }
        },
        getHotspotContentClass() {
            if (this.hotspot.componentData) {

                if (this.hotspot.componentData.type == "externalLink" && this.hotspot.slug == "breakout-session") {
                    return `Hotspot--externalLink-${this.hotspot.slug}`
                }

                return `Hotspot--${this.hotspot.componentData.type}`
            } else {
                return
            }
        },
        getAlternateHotspotIcon() {
            if (this.hotspot.data.alternateHotspotIcon !== null) {
                return {
                    'background-image': `url(${app.api.Utils.getMediaPath(this.hotspot.data.alternateHotspotIcon.src)})`
                };
            }
        },
        getContinuousHotspotAnimation() {
            // assign the looping animation on hotspots, as well as keeping them synced with resetHotspot.
            return {
                'animation-name': "hotspotLoopPulse",
                'animation-iteration-count': 'infinite',
                'animation-duration': '15s',
                'animation-delay': this.getRandomAnimationDelay(2, 14).toFixed(1) + 's'
            }
        }
    }
}
</script>


<style lang="scss">
$hotspot-height: 44px;

.Hotspot {
    display: flex;
    align-items: center;
    white-space: pre-wrap;
    font-weight: 500;
    color: var(--main-color);
    font-size: 15px;
    height: $hotspot-height - 6px;
    background: #fff;
    box-shadow: var(--shadow-small);
    z-index: 2;
    border-radius: 20px;
    transition: background-color 0.3s;

    span {
        padding: 0 18px 0 15px;
        transition: color 0.3s;
    }

    .Hotspot__button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: $hotspot-height;
        width: $hotspot-height;
        background-color: transparent;
        background-image: url(@/assets/img/ui/plus.svg);
        background-size: 20px;
        background-position: center;
        background-repeat: no-repeat;
        border: 5px solid var(--light-green);
        border-radius: 50%;
        z-index: 3;
        transition: background-color 0.5s;
    }

    &:hover {
        background: var(--light-green);

        .Hotspot__button {
            background-color: #fff;
        }

    }

    &:active {
        background: #ddd;
    }

    &--flipped {
        flex-direction: row-reverse;

        span {
            padding: 0 26px 0 18px;
            margin-left: auto;
            margin-right: -14px;
        }
    }

    // Styles for specifc components that hotspot can open
    &--fullscreenVideo,
    &--fullscreenIframePlayer {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/play.svg);
        }

        &.Hotspot--Warehouse,
        &.Hotspot--Production,
        &.Hotspot--Milk {
            .Hotspot__button {
                background-image: url(@/assets/img/ui/play-white.svg);

                &::before,
                &::after {
                    border-left-color: #fff;
                    border-right-color: #fff;
                }
            }
        }
    }

    &--externalLink {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/globe.svg);
        }
    }


    &--externalLink-breakout-session {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/icon-microsoftteams.svg) !important;
            background-size: 22px !important;
        }
    }

    &--mail {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/mail.svg);
        }
    }

    &--contentLibrary {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/icon-book-open.svg);
            background-size: 20px;
        }
    }


    &--livestreamPlayer {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/icon-livestream-dot.svg);
            background-size: 4px !important;

            // livestream icon
            &::before {
                content: '';
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border: var(--main-color) 2px solid;
                border-top-color: transparent;
                border-bottom-color: transparent;
                position: absolute;
                animation: liveicon-inner 2s infinite;
                animation-timing-function: linear;
            }

            &::after {
                content: '';
                width: 22px;
                height: 22px;
                border-radius: 50%;
                border: var(--main-color) 2px solid;
                border-top-color: transparent;
                border-bottom-color: transparent;
                position: absolute;
                animation: liveicon-outer 2s infinite;
                animation-timing-function: linear;
            }

        }

        &.Hotspot--Warehouse,
        &.Hotspot--Production,
        &.Hotspot--Milk {
            .Hotspot__button {
                background-image: url(@/assets/img/ui/icon-livestream-dot-white.svg);

                &::before,
                &::after {
                    border-left-color: #fff;
                    border-right-color: #fff;
                }
            }
        }
    }

    // Styles for specific hotspot types defined by getHotspotTypeClass()
    &--NoLabel {
        span {
            display: none;
        }
    }

    &--Production {
        background: #FFD000aa;

        .Hotspot__button {
            border-color: #fff;
            background-image: url(@/assets/img/ui/icon-cog.svg);
            background-size: 24px;
        }

        span {
            color: #fff;
        }

        &:hover {
            background: #fff;
            .Hotspot__button {
                background-color: #FFD000;
            }
            span {
                color: var(--yellow-brown)
            }
        }
    }

    &--Warehouse {
        background: #AD503Cdd;

        .Hotspot__button {
            border-color: #fff;
            background-image: url(@/assets/img/ui/icon-warehouse.svg);
            background-size: 18px;
        }

        span {
            color: #fff;
        }

        &:hover {
            background: #fff;
            .Hotspot__button {
                background-color: #AD503C;
            }
            span {
                color: var(--rusty-red)
            }
        }
    }

    &--Milk {
        background: #99BFE6dd;

        .Hotspot__button {
            border-color: #fff;
            background-image: url(@/assets/img/ui/icon-waterdrop.svg);
            background-size: 14px;
        }

        span {
            color: #fff;
        }

        &:hover {
            background: #fff;
            .Hotspot__button {
                background-color: #99BFE6;
            }
            span {
                color: var(--baby-blue-darker)
            }
        }
    }
}

/* entrance animation */
.HotspotEntrance-enter-active {
    transition: all 1s var(--tk-easeinout);
}

.HotspotEntrance-leave-active {
    transition: all 0.3s var(--tk-easeinout);
}

.HotspotEntrance-enter-from {
    transform: translateY(-300%);
    opacity: 0;
}

.HotspotEntrance-leave-to {
    opacity: 0;
}

@keyframes liveicon-inner {
    0% {
        opacity: 0;
    }


    33% {
        opacity: 1;
    }

    66% {
        opacity: 0;
    }

    100% {
        opacity: 0;
    }
}

@keyframes liveicon-outer {
    0% {
        opacity: 0;
    }

    15% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}


/* default*/
@keyframes hotspotLoopPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
        transform: scale(1.1);
    }

    7% {
        box-shadow: 0 0 0 120px rgba(255, 255, 255, 0);
        transform: scale(1.05);
    }

    10% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }
}
</style>